// require("typeface-montserrat");
require("./src/css/pageStyle.css");

// Check cookie consent on page load and initialize GA if accepted
export const onInitialClientRender = () => {
  if (typeof window !== "undefined") {
    const { checkCookieConsent } = require("./src/utils/gtag")
    checkCookieConsent()
  }
}

// export function shouldUpdateScroll(prevRouterProps, { location }) {
//   window.scrollTo(0, 0)
//   const body = document.getElementsByTagName('body')[0]
//   // add smooth scrolling
//   body.style.scrollBehavior = 'smooth'
//   body.scrollTop = 0
//   return false
// }
